import React from 'react';
import PropTypes from 'prop-types';
import OrDivider from 'common/components/or-divider';
import GoogleSignInButton from '../../google-signin-button';
import DropboxSignInButton from '../../dropbox-signin-button';

export default class ThirdPartyLogin extends React.Component {
    static propTypes = {
      googleSignInClientId: PropTypes.string.isRequired,
      getIsOptedIn: PropTypes.func.isRequired,
      formType: PropTypes.string.isRequired,
      csrfToken: PropTypes.string.isRequired,
      siteCodeString: PropTypes.string.isRequired,
      isSignup: PropTypes.bool.isRequired,
    };

    render() {
      return (
        <div>
          <div className="m-create-account--modal-google-login text-center">
            <div className="m-create-account--modal-google-login-border">
              <div className="m-create-account--modal-google-login-or-image" />
            </div>
            <div className="m-create-account--modal-google-login-button">
              <GoogleSignInButton
                clientId={this.props.googleSignInClientId}
                getIsOptedIn={this.props.getIsOptedIn}
                formType={this.props.formType}
                csrfToken={this.props.csrfToken}
                isSignup={this.props.isSignup}
                buttonAttrs={
                    {
                      'da-category': 'signup',
                      'da-action': `create account inapp - ${this.props.siteCodeString}`,
                      'da-label': 'sign in with google',
                    }
                } />
              <div className="l-margin-t-20">
                <DropboxSignInButton isSignup={this.props.isSignup} />
              </div>
            </div>
          </div>
          <OrDivider />
        </div>
      );
    }
}
